import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { iBisBaseComponent, iBisFileService, iBisLanguageService, iBisUIService } from '@dohu/ibis-common';
import notify from 'devextreme/ui/notify';
import { ModalFileService } from './modal-file.service';

@Component({
  selector: 'app-modal-file',
  templateUrl: './modal-file.component.html'
})
export class ModalFileComponent extends iBisBaseComponent {

  constructor(public override edit: ModalFileService, lg: iBisLanguageService, iui: iBisUIService, route: ActivatedRoute,
    private file: iBisFileService) {
    super(edit, lg, iui, route);
  }

  onPreviewClick = (ev: any) => {
    this.file.view(ev.row.data.fi_id);
  }

  onDownloadClick = (ev: any) => {
    this.file.download(ev.row.data.fi_id).then(
      () => { notify(this.L('FILES_DOWNLOADED'), 'success', 2000); },
      () => { notify(this.L('DOWNLOAD_ERROR'), 'error', 3000); });
  }
}
